import * as GroupType from 'constants/GroupType';

const TENNIS_GROUP_MAP = {};

TENNIS_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
TENNIS_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
TENNIS_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
TENNIS_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
TENNIS_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
TENNIS_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;

export default TENNIS_GROUP_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Tennis/GroupMap.js